import img1 from '../../images/choose/1.png'
import img2 from '../../images/choose/2.png'
import img3 from '../../images/choose/3.png'
// import img4 from "../../images/choose/4.png";
const choose = [
  {
    img: img1,
    title: 'Experience',
    text: [
      'Exciting video lectures, live-action graphics,visualizations, and user-interactive features all contribute to a rich learning experience.',
    ],
  },
  {
    img: img2,
    title: 'Practice',
    text: [
      "Learning is incomplete without the chance to exhibit what you've learned. KATON's all-inclusive courses and programs have more than enough opportunities for practice via quizzes, open-response examinations, virtual worlds, and more.",
    ],
  },
  {
    img: img3,
    title: 'Apply',
    text: [
      'The transformations you make in your mind and abilities through KATON are immediately noticeable in your day-to-day life. You can put your newfound skills to use in your current academic or professional setting right away.',
    ],
  },
  // {
  // 	img: img4,
  // 	title: "Reason Four",
  // 	text: [
  // 		"Lorem ipsum dolor sit amet, tetur ditr, sed diam nonumy eirmod or invidunt ut labore et dolore ",
  // 	],
  // },
]
export default choose
